import type { DebugPathlookupResponse } from '@ipfabric/utils/pathLookup/DebugPathlookup';
import { showPathlookupDebug } from 'components/DeviceView/model/commands/showPathlookupDebug';
import { isPathLookupGraphMetadata } from 'components/Graph/GraphState';
import type { GraphCommandFactory } from 'components/Graph/model/GraphCommandContext';

export const debugPathlookup: GraphCommandFactory =
  (cmdContext) => async () => {
    const { graphMetadata } = cmdContext.getState();
    if (!isPathLookupGraphMetadata(graphMetadata)) {
      return;
    }

    try {
      const response = await cmdContext.api.request<DebugPathlookupResponse>({
        data: graphMetadata.parameters,
        method: 'POST',
        url: `/graphs/debug-pathlookup/${graphMetadata.snapshotId}`,
      });

      cmdContext.getDeviceView().dispatch(showPathlookupDebug, {
        entries: response.entries,
        debugDevices: response.debugDevices,
      });
    } catch (e) {
      cmdContext.logError(e, 'GRAPH');
    }
  };
